module.exports = __webpack_public_path__ + "img/test.0d957013.jpg";